<div class="job-status">
  <!-- Status icon, shown in the top bar -->
  <div
    class="job-status__button-container"
    (click)="togglePanel()"
    (keydown)="null"
  >
    <button
      mat-icon-button
      class="job-status__button"
    >
      <mat-icon class="job-status__button-container__icon">
        all_inboxes
      </mat-icon>

      <mat-icon class="job-status__button-container__icon">
        expand_more
      </mat-icon>

      @if (lastStatusIcon) {
        @if (lastStatusIcon !== 'finished' && lastStatusIcon !== 'failed') {
          <span
            class="job-status__button-icon-bg small-icon-bg"
            [ngClass]="lastStatusIcon"
          >
          <i class="icon-spinner job-status__spinner-icon"></i>
        </span>
        }
        @else if (lastStatusIcon === 'finished' || lastStatusIcon === 'failed') {
          <span
            class="job-status__button-icon-bg small-icon-bg"
            [ngClass]="lastStatusIcon"
          >
            @if (lastStatusIcon === 'finished') {
              <mat-icon class="job-status__finished-icon">
                done
              </mat-icon>
            }
            @else if (lastStatusIcon === 'failed') {
              <mat-icon class="job-status__failed-icon color-white">
                close
              </mat-icon>
            }
          </span>
        }
      }
    </button>

    @if (lastStatusIcon && lastStatusIcon === 'active') {
      <div class="job-status__button-text">
        <span>
          {{'TRANS__JOB_STATUS__ONGOING' | translate}}
        </span>
      </div>
    }
  </div>

  <!-- Overlay, active when clicked -->
  @if (clicked) {
    <ng-container>
      <div
        class="job-status__dropdown"
        [ngClass]="{'ongoing': lastStatusIcon === 'active'}"
      >
        <div class="job-status__dropdown-inner-container">
          <!-- Tabs: start -->
          <mat-tab-group mat-align-tabs="start">
            <!-- Current user -->
            <mat-tab [label]="'TRANS__JOB_STATUS__YOUR_OPERATIONS' | translate">
              @for (m of getMessages(true); track $index) {
                <div>
                  <ng-container>
                    <app-job-status-message-list
                      [message]="m"
                      [afterExpand]="temporaryCancelJobSubscriber"
                      [afterCollapse]="initJobSubscriber"
                      [downloadReport]="downloadReport"
                      [downloadReportV2]="downloadReportV2"
                      (closePanel)="togglePanel()"
                      (showError)="showError($event)"
                    ></app-job-status-message-list>
                  </ng-container>
                </div>
              }
            </mat-tab>

            @if (adminUser) {
              <ng-container>
                <!-- Admin: All users -->
                <mat-tab [label]="'TRANS__JOB_STATUS__ALL_OPERATIONS' | translate">
                  @for (m of getMessages(false); track $index) {
                    <div>
                      <ng-container>
                        <app-job-status-message-list
                          [message]="m"
                          [afterExpand]="temporaryCancelJobSubscriber"
                          [afterCollapse]="initJobSubscriber"
                          [downloadReport]="downloadReport"
                          [downloadReportV2]="downloadReportV2"
                          (closePanel)="togglePanel()"
                          (showError)="showError($event)"
                        ></app-job-status-message-list>
                      </ng-container>
                    </div>
                  }
                </mat-tab>
              </ng-container>
            }
          </mat-tab-group>
          <!-- Tabs: end -->
        </div>
      </div>
    </ng-container>
  }
</div>

<!-- Overlay displayed when a job has just finished -->
@if (finishedJob && !clicked) {
  <ng-container>
    <div class="job-status__alert-container">
      <div class="job-status__alert">
        <div class="job-status__alert-icon">
          <div class="large-icon-bg finished">
            <mat-icon class="job-status__alert-finished-icon color-white">
              done
            </mat-icon>
          </div>
        </div>

        <div class="bold">
          <span>
            {{'TRANS__JOB_STATUS__FINISHED' | translate}}
          </span>
          :
          <span>
            {{finishedJob.task_name | translate}}
          </span>
        </div>

        @if (finishedJob.task_type === 'reports') {
          <div class="job-status__alert-download-button">
            <button
              class="job-status__download-button"
              mat-stroked-button
              color="primary"
              (click)="downloadReport(finishedJob.queue_id, finishedJob.filetype)"
            >
              <mat-icon>
                print
              </mat-icon>

              <span class="bold">
                {{'TRANS__JOB_STATUS__DOWNLOAD' | translate}}
              </span>
            </button>
          </div>
        }

        @if (finishedJob.ref) {
          <div class="job-status__alert-download-button">
            <a
              mat-stroked-button
              color="primary"
              [routerLink]="primusStateMapper.routerLinkFromState(finishedJob.ref)"
              [queryParams]="primusStateMapper.queryParams(finishedJob.refParams)"
              queryParamsHandling="merge"
            >
              <span>
                {{'TRANS__JOB_STATUS__OPEN' | translate}}
              </span>
            </a>
          </div>
        }
      </div>
    </div>
  </ng-container>
}

<!-- Overlay displayed when job is activated -->
@if (getShowActiveDialog()) {
  <div class="job-status__alert-container">
    <div class="job-status__alert job-status__activated">
      <div class="job-status__alert-icon">
        <div
          (click)="clicked = true; hideActiveDialog();"
          (keydown)="null"
          class="job-status__alert-icon-container large-icon-bg active"
        >
          <i class="icon-spinner job-status__activated-spinner-icon color-white"></i>
        </div>
      </div>

      <div>
        <span class="bold">
          {{'TRANS__JOB_STATUS__OPERATION_STARTED' | translate}}
        </span>
      </div>

      <div class="tone-down-color">
        <span>
          {{'TRANS__JOB_STATUS__MORE_INFORMATION' | translate}}
        </span>
      </div>
    </div>
  </div>
}

@if (clicked) {
  <div
    class="job-status__dropdown-overlay"
    (click)="togglePanel()"
    (keydown)="null"
  ></div>
}
